import { fieldsToObject, arrayToObject } from '../utils/objectify';

let module = angular.module('app.resources');

const transformAccountResponse = (data) => {
  const account = angular.fromJson(data);

  // Some fields that might be blank strings we actually want to be empty hashes
  if (!account['content_settings']) account['content_settings'] = {};
  if (!account['metadata']) account['metadata'] = {};

  // Some fields are space-separated lists (or arrays) of flags. Turn these into objects
  // where the flags become keys and the values are boolean.
  account['feature_flags'] = arrayToObject(account['feature_flags'] || []);
  account['extra_features'] = fieldsToObject(account['extra_features'] || '');
  account['usage_flags'] = fieldsToObject(account['usage_flags'] || '');

  return account;
};

module.factory('Account', ($resource, $cacheFactory) => {
  'ngInject';
  const Account = $resource(
    `${API_ROOT}/account`,
    {},
    {
      get: {
        method: 'GET',
        cache: true,
        transformResponse: transformAccountResponse,
      },

      update: {
        method: 'PUT',
        transformResponse: transformAccountResponse,
      },

      // Scoreboard configuration
      getScoreboard: {
        method: 'GET',
        url: `${API_ROOT}/account/scoreboard_configuration`,
      },
      updateScoreboard: {
        method: 'PUT',
        url: `${API_ROOT}/account/scoreboard_configuration`,
      },

      // Sportzcast Integration
      getSportzcast: {
        method: 'GET',
        url: `${API_ROOT}/account/sportzcast_configuration`,
      },
      updateSportzcast: {
        method: 'PUT',
        url: `${API_ROOT}/account/sportzcast_configuration`,
      },

      // Kaltura Integration
      getKaltura: {
        method: 'GET',
        url: `${API_ROOT}/account/kaltura_configuration`,
      },
      updateKaltura: {
        method: 'PUT',
        url: `${API_ROOT}/account/kaltura_configuration`,
      },

      // Billing
      getBilling: {
        method: 'GET',
        url: `${API_ROOT}/account/billing`,
      },
      updateBilling: {
        method: 'PUT',
        url: `${API_ROOT}/account/billing`,
      },

      // Upgrades
      getUpgrades: {
        method: 'GET',
        url: `${API_ROOT}/account/upgrades`,
        isArray: true,
      },
      createUpgrade: {
        method: 'POST',
        url: `${API_ROOT}/account/upgrades`,
      },
      getProducts: {
        method: 'GET',
        url: `${API_ROOT}/account/products`,
        isArray: true,
      },

      // Caption Vocabulary
      getCaptionVocabulary: {
        method: 'GET',
        url: `${API_ROOT}/account/caption_vocabulary`,
      },
      updateCaptionVocabulary: {
        method: 'PUT',
        url: `${API_ROOT}/account/caption_vocabulary`,
      },

      // Usage summaries
      getUsageSummaries: {
        method: 'GET',
        url: `${API_ROOT}/account/usage_summaries`,
        isArray: true,
      },
    }
  );
  angular.extend(Account.prototype, {
    authorized: function () {
      let ret = this.can_stream;
      if (this.contract == 'trial' && moment(this.expires_on).toDate() < new Date()) {
        ret = false;
      } else if (this.contract == 'trial' && this.status == 'initial') {
        ret = false;
      }
      return ret;
    },
    defaultReportState: function () {
      // Prefer viewer analytics, but fall back to tickets or donations
      if (!this.feature_flags.analytics) {
        if (!this.feature_flags.no_ticketed) {
          return 'reports.tickets';
        } else if (this.feature_flags.donations) {
          return 'reports.donations';
        }
      }
      return 'reports.viewer';
    },
    isTrialing: function () {
      return this.contract == 'trial';
    },
    refresh: function () {
      $cacheFactory.get('$http').remove(`${API_ROOT}/account`);
      return Account.get().$promise.then((newAccount) => {
        Object.keys(newAccount).forEach((k) => {
          this[k] = newAccount[k];
        });
        return this;
      });
    },
    showOnboarding: function () {
      // TODO remove this when no longer testing product tours [UA-1023]
      const hasProductTourFlag = this.extra_features.product_tour;

      return this.status == 'onboarding' && this.metadata.onboarding_step && !hasProductTourFlag;
    },
  });
  return Account;
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/account.js